import { type Context, createContext } from "react";

/**
 * Create a context without a default value, whose provider must be explicitly present in the tree in order for
 * consumers to work.
 */
export function createRequiredContext<T extends object>(exceptionMessage: string): Context<T> {
    return createContext<T>(getThrower<T>(exceptionMessage));
}

/** Get an object that throws an exception upon any attempt to read its properties */
export function getThrower<T extends object>(exceptionMessage: string) {
    const handler: ProxyHandler<T> = {
        get(_, property) {
            throw new Error(`${exceptionMessage} (reading ${propNameToString(property)})`);
        },
        has(_, property) {
            throw new Error(`${exceptionMessage} (checking ${propNameToString(property)})`);
        },
    };

    return new Proxy({} as T, handler);
}

function propNameToString(property: string | symbol) {
    switch (typeof property) {
        case "string":
            return property;
        case "symbol":
            return ":symbol";
    }
}
